import * as React from "react";
const SvgIcChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 6L8 11L13 6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
export default SvgIcChevronDown;
